import { CopyButton } from "components/Embeds/CopyButton";
import { EmbedButton } from "components/Embeds/EmbedButton";
import { Box, Icon, Input, Stack, Text, styled } from "prism-react";
import React from "react";

const StyledSection = styled(Box, {
  padding: "$4 $5",
});

export const ShareContainer: React.FC<{
  children: React.ReactNode;
  editorURL: URL;
  showShareOptions?: boolean;
}> = ({ children, editorURL, showShareOptions = true }) => {
  return (
    <Stack
      css={{
        height: "100%",
        "> *:not(:first-child)": { borderTop: "1px solid $neutral-bg-focus" },
      }}
      gap={0}
    >
      <StyledSection
        css={{
          paddingBottom: "$3",
        }}
      >
        {children}
      </StyledSection>

      {showShareOptions && (
        <>
          <StyledSection css={{ paddingTop: "$3", paddingBottom: "$3" }}>
            <Stack gap={3}>
              <Stack
                css={{ justifyContent: "space-between", width: "100%" }}
                horizontal
              >
                <Stack horizontal>
                  <Icon size={4} type="hyperlink" />
                  <Text>Share URL</Text>
                </Stack>
              </Stack>
              <Stack css={{ width: "100%" }} gap={0} horizontal>
                <Input
                  css={{
                    flex: 1,
                    borderRadius: "$2 0 0 $2",
                    border: "1px solid $neutral-bg-high",
                    borderRight: "none",
                  }}
                  onClick={(e) => {
                    const inputElement = e.target as HTMLInputElement;
                    inputElement.select();
                  }}
                  value={editorURL.toString()}
                  readOnly
                />

                <CopyButton
                  content={editorURL.toString()}
                  css={{
                    borderRadius: "0 $2 $2 0",
                  }}
                  type="share"
                  variant="secondary"
                >
                  Copy
                </CopyButton>
              </Stack>
            </Stack>
          </StyledSection>

          <StyledSection css={{ paddingTop: "$3", paddingBottom: "$3" }}>
            <EmbedButton editorURL={editorURL} />
          </StyledSection>
        </>
      )}
    </Stack>
  );
};
